<template>
    <q-list>
      <q-img src="img/marina.png" style="width: 100%; height: 135px">
      <!-- <div class="absolute-bottom text-subtitle1">
          <div class="row">
              <div class="col col-md-12">
                  <span class="h_card_sidebar1">NAMA KECAMATAN</span>
              </div>
          </div>
      </div> -->
    </q-img>

    <q-item-label class="bg-purple-5" header><span style="color:white">{{profile.nama}}</span></q-item-label>

    <q-item clickable to="/" exact >
      <q-item-section top avatar>
        <q-avatar color="indigo-7" text-color="white" icon="dashboard" />
      </q-item-section>
      <q-item-section>
        <q-item-label>Dashboard</q-item-label>
      </q-item-section>
    </q-item>
    <q-item clickable to="/pelaku" v-if="profile.menu_klp == 19" exact >
      <q-item-section top avatar>
        <q-avatar icon="light_mode" color="blue-7" text-color="white" />
      </q-item-section>
      <q-item-section>
        <q-item-label>Brand</q-item-label>
      </q-item-section>
    </q-item>
    <q-item clickable to="/produk" v-if="profile.menu_klp == 19" exact >
      <q-item-section top avatar>
        <q-avatar icon="shopping_bag" color="light-blue-7" text-color="white" />
      </q-item-section>
      <q-item-section>
        <q-item-label>Produk</q-item-label>
      </q-item-section>
    </q-item>
    <q-item clickable to="/banner" v-if="profile.menu_klp == 17" exact >
      <q-item-section top avatar>
        <q-avatar icon="image" color="light-blue-7" text-color="white" />
      </q-item-section>
      <q-item-section>
        <q-item-label>Banner</q-item-label>
      </q-item-section>
    </q-item>
    <q-expansion-item :content-inset-level="1" v-if="profile.menu_klp == 17" >

      <template v-slot:header>
        <q-item-section avatar>
          <q-avatar icon="shopping_bag" color="blue-7" text-color="white" />
        </q-item-section>
        <q-item-section>Industri Rumah Tangga</q-item-section>
      </template>
      
      <q-list :content-inset-level="0.5" > 

        <q-item clickable to="/pelaku" :content-inset-level="0.5"  >
          <q-item-section>Pelaku</q-item-section>
        </q-item>

        <q-item clickable to="/produk" :content-inset-level="0.5"  >
          <q-item-section>Produk</q-item-section>
        </q-item>

      </q-list>
    </q-expansion-item>
    <q-item clickable to="/umum" v-if="profile.menu_klp == 17" exact >
      <q-item-section top avatar>
        <q-avatar icon="file_copy" color="light-blue-7" text-color="white" />
      </q-item-section>
      <q-item-section>
        <q-item-label>Data Umum</q-item-label>
      </q-item-section>
    </q-item>
     <q-expansion-item :content-inset-level="1" v-if="profile.menu_klp == 17" >

      <template v-slot:header>
        <q-item-section avatar>
          <q-avatar icon="settings_applications" color="cyan-7" text-color="white" />
        </q-item-section>
        <q-item-section>Data Master</q-item-section>
      </template>
      
      <q-list :content-inset-level="0.5" > 

        <q-item clickable to="/kategori" :content-inset-level="0.5"  >
          <q-item-section>Kategori</q-item-section>
        </q-item>

        <q-item clickable to="/pengguna" :content-inset-level="0.5"  >
          <q-item-section>Pengguna</q-item-section>
        </q-item>

        <q-item clickable to="/level" :content-inset-level="0.5"  >
          <q-item-section>Level Pengguna</q-item-section>
        </q-item>

      </q-list>
    </q-expansion-item>

    <q-item clickable @click="logout" exact>
      <q-item-section top avatar>
        <q-avatar color="red-7" text-color="white" icon="exit_to_app" />
      </q-item-section>
      <q-item-section>
        <q-item-label>Keluar</q-item-label>
        <q-item-label caption lines="2">Logout</q-item-label>
      </q-item-section>
    </q-item>
      </q-list>
</template>

<script>
export default {
  data() {
    return {
      // user: "",
      profile : {
					nama : '',
					menu_klp : '',
          unitKerja : '',
				},
    };
  },

  methods: {
    logout : function(){
        localStorage.removeItem('token');
        localStorage.removeItem('profile');
        this.$router.push('/login');
    },
  },
  mounted: function(){
    var get_profile = JSON.parse(localStorage.profile);

    console.log(get_profile);
    // this.profile.unit_kerja = get_profile.profile.unit_kerja_nama;
    this.profile.nama = get_profile.profile.nama;
    this.profile.menu_klp = get_profile.profile.menu_klp;
    // this.profile.unitKerja = get_profile.profile.unit_kerja_id;
  },
  
};
</script>